import React from "react";
import styles from "./Loader.module.css";

export default function Loader() {
  return <p className={styles.text}>Loading movies, please wait...</p>;
}
